import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesReturn } from '../../../../../hooks/entities/selectors/returns';
import Content from './content';

const ReadOnlyContainer = ({ returnFulfillmentId }) => {
  const returnEntity = useEntitiesReturn(returnFulfillmentId) || emptyObject;

  const { rmaNumber, returnConfiguration, voidedDateTime, receivedDateTime, createdDateTime } = returnEntity;

  const shipTo = returnConfiguration?.shipTo || emptyObject;

  const returnShipmentDetails = useMemo(() => {
    return {
      shipTo,
      rmaNumber,
      voidedDateTime,
      receivedDateTime,
      createdDateTime,
    };
  }, [createdDateTime, receivedDateTime, rmaNumber, shipTo, voidedDateTime]);

  return <Content returnShipmentDetails={returnShipmentDetails} />;
};

export default ReadOnlyContainer;

ReadOnlyContainer.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
};
